import { Component } from '@angular/core';

@Component({
  selector: 'em-intro',
  styleUrls: ['./intro.component.less'],
  templateUrl: './intro.component.html',
  standalone: false,
})
export class IntroComponent {}
